import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { MapLayerService } from 'src/app/services/map-layer/map-layer.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-action-list',
  templateUrl: './action-list.component.html',
  styleUrls: ['./action-list.component.sass']
})
export class ActionListComponent implements OnInit {
  _maps = [];
  MAX_MAP_VIEW_COUNT;
  isTimeline = false

  @Output() onTimelineToggled: EventEmitter<any> = new EventEmitter();

  constructor(
    private splitViewService: SplitViewService,
    private locationStore: LocationStoreService,
    private toastr: ToastrService,
    private _t: TranslateService,
    private mapLayerService: MapLayerService,
  ) { }

  ngOnInit(): void {
    this.splitViewService.onEvent$.subscribe(res => {
      this._maps = this.splitViewService.mapViews.map(mapView => mapView.map)
    })
    this.MAX_MAP_VIEW_COUNT = this.splitViewService.MAX_MAP_VIEW_COUNT
  }

  onClickAdd() {
    if (this.splitViewService.isEditingAnnotation)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant(`Please exit annotation edit/create page`));

    const currentLocation = this.locationStore.currLocation$.getValue()
    if (!currentLocation.id)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant('Please enter a project'));

    const res = this.mapLayerService.timelineMaplayer$.getValue()
    const totalSplitScreen = this.splitViewService.mapViews.length + 1
    if (res.length < totalSplitScreen)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant(`Only ${res.length} ortho(s) available`, { num: res.length }));

    this.isTimeline = true
    this.onTimelineToggled.emit(this.isTimeline)
    // this.splitViewService.onEvent$.next({ onClickAdd: true })
    this.splitViewService.addingMap = true
  }

  onClickRemove() {
    if (this.splitViewService.isEditingAnnotation)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant(`Please exit annotation edit/create page`));

    this.splitViewService.onEvent$.next({ onClickRemove: true })
    if (this._maps.length <= 1) {
      this.isTimeline = false
      this.onTimelineToggled.emit(this.isTimeline)
    }
  }

  onClickUnsync() {
    if (this.splitViewService.isEditingAnnotation)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant(`Please exit annotation edit/create page`));

    this.splitViewService.onEvent$.next({ onClickUnsync: true })
  }

  onClickResync() {
    if (this.splitViewService.isEditingAnnotation)
      return this.toastr.error(this._t.instant('Invalid Action'), this._t.instant(`Please exit annotation edit/create page`));

    this.splitViewService.onEvent$.next({ onClickResync: true })
  }

  // toggleTimeline() {
  //   this.isTimeline = !this.isTimeline
  // }
}
